import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { AlertComponent } from '../../../../../common/alert/alert.component';
import {
  IrspaDetailedInformationOnTheLetterContentPreviewComponent
} from '../../common/irspa-detailed-information-on-the-letter-content-section/components/irspa-detailed-information-on-the-letter-content-preview/irspa-detailed-information-on-the-letter-content-preview.component';
import {
  IrspaDetailedInformationAboutCadastralPlotsPreviewComponent
} from '../../common/irspa-detailed-information-about-cadastral-plots-section/components/irspa-detailed-information-about-cadastral-plots-preview/irspa-detailed-information-about-cadastral-plots-preview.component';
import {
  IrspaLetterContentPreviewComponent
} from '../../common/irspa-letter-content-section/components/irspa-letter-content-preview/irspa-letter-content-preview.component';

@Component({
  selector: 'app-irspa-application-for-the-project-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    AlertComponent,
    IrspaDetailedInformationOnTheLetterContentPreviewComponent,
    IrspaDetailedInformationAboutCadastralPlotsPreviewComponent,
    IrspaLetterContentPreviewComponent
  ],
  templateUrl: './irspa-application-for-the-project-preview.component.html'
})
export class IrspaApplicationForTheProjectPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public ngOnInit(): void {
  }

}
